import gql from 'graphql-tag';
import { kmsClient } from 'api';
import { useMutation } from '@apollo/react-hooks';
import {
  CreateContentDataSourceMutation,
  CreateContentDataSourceMutationVariables
} from './__generated__/CreateContentDataSourceMutation';

const CREATE_CONTENT_DATA_SOURCE_MUTATION = gql`
  mutation CreateContentDataSourceMutation($name: String!, $path: String!, $dataSourceType: String!) {
    createContentDataSource(name: $name, path: $path, dataSourceType: $dataSourceType) {
      contentDataSource {
        id
        name
        path
        dataSourceType
      }
      errors
    }
  }
`;

export const useCreateContentDataSourceMutation = () => {
  return useMutation<CreateContentDataSourceMutation, CreateContentDataSourceMutationVariables>(
    CREATE_CONTENT_DATA_SOURCE_MUTATION,
    {
      client: kmsClient
    }
  );
};
